import { SearchInput } from "@jugl-web/ui-components/cross-platform/SearchInput";
import { useSearchInput } from "@jugl-web/utils";
import { useInvoicesItemsPage } from "../../context/useInvoicesItemsPage";

export const InvoicesSearch = () => {
  const { setSearchQuery, immediateSearchQuery } = useInvoicesItemsPage();
  const { inputProps, reset } = useSearchInput({
    onSearch: (value) => setSearchQuery(value),
    onReset: () => setSearchQuery(""),
    debounce: 0, // Remove debouncing here since it's handled at the provider level
    defaultValue: immediateSearchQuery || "",
  });
  return (
    <SearchInput
      onClear={reset}
      variant="filled"
      color="white"
      {...inputProps}
    />
  );
};
